import { formLabelClasses } from '@mui/material';

export const muiFormLabelOverrides = {
	styleOverrides: {
		root: () => {
			return {
				[`.${formLabelClasses.asterisk}`]: { opacity: 1 },
			};
		},
	},
};
